// const apiVersion = 'v1';
const backendHost = 'https://api-vlrg.osram.info';

let API_HOST = backendHost;
export default API_HOST;
